// Small deterministic PRNG (xorshift32, Marsaglia 2003) so that simulations,
// procedural surfaces and tests reproduce exactly from a seed.

export function createRng(seed = 1) {
  let state = (Number(seed) >>> 0) || 0x9e3779b9;
  const next = () => {
    state ^= state << 13;
    state >>>= 0;
    state ^= state >>> 17;
    state ^= state << 5;
    state >>>= 0;
    return state / 4294967296;
  };
  return {
    next,
    range: (min, max) => min + (max - min) * next(),
    normal: () => {
      const u = Math.max(1e-12, next());
      const v = next();
      return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
    },
    getState: () => state,
    setState: (value) => { state = (value >>> 0) || 0x9e3779b9; },
  };
}

// Stateless integer hash, for per-cell values that must not depend on evaluation order.
export function hash2(x, y, seed = 0) {
  let h = (Math.imul(x | 0, 0x27d4eb2d) ^ Math.imul(y | 0, 0x165667b1) ^ Math.imul(seed | 0, 0x9e3779b1)) >>> 0;
  h = Math.imul(h ^ (h >>> 15), 0x85ebca6b) >>> 0;
  h = Math.imul(h ^ (h >>> 13), 0xc2b2ae35) >>> 0;
  return ((h ^ (h >>> 16)) >>> 0) / 4294967296;
}
